module.exports = __webpack_public_path__ + "static/Inigo-a2e09c38c0a04f74f833dc81ac94cc08.webp";